<template>
  <FormulateInput
    :options="_options"
    :type="type"
    v-model="_value"
    v-bind="$attrs"
    :label="label"
    class="ews-radio"
    outerClass=""
    :wrapperClass="['ews-radio-wrapper', wrapperClass]"
    :elementClass="['ews-radio-element', elementClass]"
    :inputClass="['', inputClass]"
    :labelClass="['', labelClass]"
    helpClass="text-cool-gray-500 font-light text-sm ml-1"
    errorClass="text-red-700 font-light text-sm ml-1"
  />
</template>

<script>
export default {
  components: {},
  inheritAttrs: false,
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    _options() {
      let options = this.options

      if (Array.isArray(this.options) && (typeof this.options[0] == 'string' || typeof this.options[0] == 'number')) {
        options = this.options.map((item, i) => {
          let id = `radio-${item.toString().toLowerCase().trim()}-${i}`

          return {
            value: item.toString(),
            label: item.toString(),
            id: id
          }
        })
      } else if (Array.isArray(this.options) && !this.options[0].id) {
        options = this.options.map((item, i) => {
          let id = `radio-${item.value.toString().toLowerCase().trim()}-${i}`

          return { ...item, id: id }
        })
      }

      // console.log(this.options, options)
      return options
    }
  },
  props: {
    /**
     * Type of box can either be 'checkbox' or 'radio'.
     */
    type: {
      type: String,
      default: 'radio'
    },
    /**
     * Optional label element above text input.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Default (current) value.
     * @model
     */
    value: [String, Number, Boolean],
    /**
     * This can be an array of values, array of objects or an object.
     */
    options: [Object, Array],
    /**
     * CSS classes on the input itself.
     */
    inputClass: {
      type: String,
      default: ''
    },
    /**
     * CSS classes on the input and label grouping.
     * Set this to `flex` to make the options inline instead of block.
     */
    elementClass: {
      type: String,
      default: ''
    },
    /**
     * CSS classes for label.
     */
    labelClass: {
      type: String,
      default: ''
    },
    /**
     * CSS classes for wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="postcss" scoped>
.ews-radio >>> .ews-radio-element {
  @apply ml-1;
}
.ews-radio >>> .formulate-input .formulate-input-wrapper {
  @apply flex items-center;
}
.ews-radio >>> .formulate-input .formulate-input-wrapper label {
  @apply font-light my-0;
}
.ews-radio >>> .formulate-input-element--checkbox {
  @apply flex;
}
.ews-radio >>> .formulate-input-label--after {
  @apply ml-2;
}
.ews-radio >>> .formulate-input-element--radio {
  @apply flex items-center;
}
.ews-radio >>> .formulate-input-element--radio input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-shrink: 0;
  height: 1.1rem;
  width: 1.1rem;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.55rem;
  @apply bg-white text-blue-500;
}
.ews-radio >>> .formulate-input-element--radio input:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
